"use strict";
var Observable_1 = require("../../Observable");
var skipUntil_1 = require("../../operator/skipUntil");
Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
//# sourceMappingURL=skipUntil.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/skipUntil.js
 ** module id = 391
 ** module chunks = 1
 **/